var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h2',[_vm._v("Registration Successful")])]),_c('div',{staticClass:"col-12 text-center h4 py-5"},[_vm._v("\n        Your account has been registered successfully."),_c('br'),_vm._v("\n        Check your email to activate it.\n    ")])])
}]

export { render, staticRenderFns }